import { useAuth } from '@/hooks/useAuth';
import { truncateWalletAddress } from '@/utils';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { GoPeople } from 'react-icons/go';
import { CopyText } from '../copy-text';
import { GoonAvatar } from '../goon-avatar';
import { RoundedButton } from '../rounded-button';
import { DialogBody, DialogCloseTrigger, DialogContent, DialogRoot, DialogTrigger } from '../ui/dialog';
import { InviteFriendsModal } from './invite-friends-modal';

export const ConnectedWalletModal = () => {
  const [open, setOpen] = useState(false);
  const { address, logout } = useAuth();
  return (
    <DialogRoot size="md" open={open} onOpenChange={(e) => setOpen(e.open)}>
      <DialogTrigger asChild>
        <RoundedButton
          w="full"
          variant="outline"
          h="58px"
          display="flex"
          justifyContent="start"
          _hover={{
            bgColor: '#F8FAFC',
          }}
        >
          <GoonAvatar seed={address} mr={2} />
          <Text fontSize="md" fontWeight="400" color="fg.muted">
            {truncateWalletAddress(address)}
          </Text>
        </RoundedButton>
      </DialogTrigger>
      <DialogContent p={4}>
        <DialogBody>
          <VStack alignItems="center">
            <GoonAvatar seed={address} boxSize={16} />
            <CopyText value={address}>
              <Text fontWeight="700" fontSize="lg" color="fg.muted">
                {truncateWalletAddress(address)}
              </Text>
            </CopyText>
            <InviteFriendsModal
              variant="outline"
              triggerOverride={
                <RoundedButton variant="outline" w="full" h={58} mt={4}>
                  <GoPeople />
                  Invite Friends
                </RoundedButton>
              }
            />
            <HStack w="full">
              <RoundedButton flex={1} h={58} variant="outline" onClick={() => setOpen(false)}>
                Close
              </RoundedButton>
              <RoundedButton flex={1} h={58} variant="outline" colorPalette="red" onClick={logout}>
                Disconnect
              </RoundedButton>
            </HStack>
          </VStack>
        </DialogBody>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};
